<template>
  <div>
    <div class="header">
      <!-- <div class="top">
        <div class="w1300">
          <div class="top-left">{{web_index_welcome}}</div>
          <div class="top-right">
            {{web_index_phone}}
            <img
              src="../assets/images/header_img.png"
              alt=""
              class="header_img"
            />
          </div>
        </div>
      </div> -->
      <div class="logo-box">
        <div class="w1300">
          <img src="../assets/images/20.jpg" alt="" />
          <!-- <img src="../assets/images/2.png" alt="" />
          <p class="top-title">承德 “热河嫂” 巾帼家政</p> -->
        </div>
      </div>
      <div class="w1300">
        <div class="nav">
          <div class="nav-list">
            <div
            class="nav-li"
              v-for="(item, index) in headerList"
              :key="index"
              @click="goNav(item.url,item.hasChildren,item.id)"
            >
              {{ item.title }}
              <!-- <ul v-if="item.children == 1 && nav_index == index " class="children"> -->
              <ul v-if="item.hasChildren == 1 && nav_index == index && isShow" class="children">
                <li v-for="(item1,index1) in item.children" :key="index1"  @click.stop="goNav1(item.url,item.id,item1.id)">
                  {{ item1.title }}
                </li>
              </ul>
            </div>
          </div>
          <div class="search">
            <input type="text" class="search-input" v-model="key"/>
            <img src="../assets/images/16.png" alt="" class="search-img" @click="goSearch()"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    active: {
      type: Number,
      default: 0,
      
    },
  },
  data() {
    return {
      nav_index:"",
      activeId:this.active,
      isShow:true,
      // headerList: [
      //   {
      //     title: "首页",
      //     url: "/",
      //     children:0,
      //   },
      //   {
      //     title: "品牌建设",
      //     url: "/pinpaijianshe",
      //     children:1,
      //     childrenList:[{ title: "品牌背景" }, { title: "品牌发展" }, { title: "品牌成果" }]
      //   },
      //   {
      //     title: "咨询中心",
      //     url: "/zixunzhongxin",
      //     children:1,
      //     childrenList:[{ title: "县区动态" },{ title: "基地建设" },{ title: "职场信息" },{ title: "风采展示" },{ title: "其他" }]
      //   },
      //   {
      //     title: "巾帼家政",
      //     url: "/jinguojiazheng",
      //     children:1,
      //     childrenList:[{ title: "巾帼家政" }, { title: "热河嫂" }]
      //   },
      //   {
      //     title: "课程中心",
      //     url: "/kechengzhongxin",
      //     children:1,
      //     childrenList:[{ title: "课程资源" }, { title: "直播动态" }]
      //   },
      //   {
      //     title: "家政先锋",
      //     url: "/jiazhengxianfeng",
      //     children:1,
      //     childrenList:[{ title: "星级基地" }, { title: "星级河北" }, { title: "星级热河嫂" }]
      //   },
      //   {
      //     title: "家政服务",
      //     url: "/jiazhengfuwu",
      //     children:0,
      //   },
      //   {
      //     title: "政治法规",
      //     url: "/zhengzhifagui",
      //     children:0,
      //   },
      //   {
      //     title: "走进我们",
      //     url: "/about",
      //     children:0,
      //     child_index:0,//子级选中index
      //   },
      // ],
      headerList: [
        {
          title: "首页",
          url: "/",
          hasChildren:2,
          type:2
        },
      ],
      web_index_phone:"",
      web_index_welcome:"",
      key:''
    };
  },
  methods:{
    goNav(url,type,index){
      if(type == 0){
        this.$router.push(url+'/'+index);
      }else if(type == 2){
        this.$router.push(url);
      }else{
        this.isShow = true
        this.nav_index = index
        this.activeId = index
      }
      
    },
    goNav1(url,cate_id,index){
      if(this.nav_index == cate_id){
        this.isShow = false
      }
      this.$router.push(url+'/'+cate_id+'/'+index,()=>{},()=>{});
      this.$emit("navChilIndex",index)
      
    },
    async navigation(){
      let res = await this.$get('/web/index/navigation');
      if(res.code == 200){
        res.data.forEach((item)=>{
          this.headerList.push(item)
        });
      }
    },
    async setting() {
      let res = await this.$get("/web/index/setting");
      if (res.code == 200) {
        this.web_index_phone = res.data.web_index_phone
        this.web_index_welcome = res.data.web_index_welcome
      }
    },
    goSearch(){
      if(this.key !=""){
        this.$router.push('/search'+'/'+this.key,()=>{},()=>{});
      }
      
    }
  },
  mounted(){
    this.navigation();
    this.setting();
  }
};
</script>

<style scoped>
.top {
  height: 40px;
  background-color: #ba0000;
  color: #fff;
  line-height: 40px;
  font-size: 15px;
}
.top-left {
  float: left;
}
.top-right {
  float: right;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header_img {
  width: 25px;
  margin-left: 20px;
}
.logo-box {
  border-bottom: solid 2px #ba0000;
  /* margin-top: 30px;
  padding-bottom: 30px; */
}
.logo-box img {
  width: 100%;
  /* margin-right: 20px; */
}
.logo-box .w1300 {
  display: flex;
  align-items: center;
}
.top-title {
  font-size: 40px;
  margin-left: 30px;
  font-weight: bold;
  color: #ba0000;
  letter-spacing: 2px;
}
.nav {
  margin-top: 10px;
  display: flex;
  align-items: center;
}
.nav-li {
  padding: 10px 26px;
  margin: 0 5px;
  float: left;
  position: relative;
}
.nav ul li:hover,.nav-li{cursor: pointer;}
.search {
  margin-left: 20px;
  position: relative;
  width: 150px;
  height: 40px;
  border: none;
  background-color: #eeeeee;
  border-radius: 10px;
}
.search-input {
  width: 90px;
  height: 40px;
  border: none;
  padding-left: 10px;
  background-color: #eeeeee;
  border-radius: 10px;
  outline: none;
}
.search-img {
  width: 25px;
  position: absolute;
  right: 12px;
  top: 7px;
}
.active {
  color: #fff;
  background-color: #ba0000;
}
.nav-li:hover{color: #fff;background-color: #ba0000;}
.children{position: absolute;top: 55px;border: solid 1px #bf010b;background-color: #fff;left: 0;z-index: 9;width: 100%;}
.children li{padding: 13px 0;color: #000;font-size: 14px;text-align: center;width: 100%;}
.children li:hover{color: #fff;background-color: #cb4343;}
</style>